import React from "react";
import Select from "react-select";

const FilterDropdowns = ({
  warehouses,
  items,
  onFilterChange,
  selectedWarehouse,
  selectedCategory,
  selectedItemName,
}) => {
  // Custom styles for react-select to match existing styling
  const customStyles = {
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999,
    }),
    control: (provided) => ({
      ...provided,
      minHeight: "32px",
      height: "32px",
      borderRadius: "6px",
    }),
    valueContainer: (provided) => ({
      ...provided,
      height: "32px",
      padding: "0 4px",
    }),
    input: (provided) => ({
      ...provided,
      margin: 0,
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: "32px",
    }),
  };

  // Prepare options for react-select
  const warehouseOptions = [
    { value: "", label: "All Warehouses" },
    ...warehouses.map((warehouse) => ({
      value: warehouse.warehouseName,
      label: warehouse.warehouseName,
    })),
  ];

  const categoryOptions = [
    { value: "", label: "All Categories" },
    ...[...new Set(items.map((item) => item.itemCategory))].map((category) => ({
      value: category,
      label: category,
    })),
  ];

  const itemNameOptions = [
    { value: "", label: "All Items" },
    ...[...new Set(items.map((item) => item.itemName))].map((itemName) => ({
      value: itemName,
      label: itemName,
    })),
  ];

  // Handle change for react-select
  const handleSelectChange = (filterType, selectedOption) => {
    const value = selectedOption ? selectedOption.value : "";
    onFilterChange(filterType, value);
  };

  return (
    <>
      <div className="w-full">
        <Select
          options={warehouseOptions}
          value={warehouseOptions.find(
            (option) => option.value === selectedWarehouse
          )}
          onChange={(selected) => handleSelectChange("warehouse", selected)}
          styles={customStyles}
          placeholder="Select Warehouse"
          menuPortalTarget={document.body}
          isClearable
        />
      </div>
      <div className="w-full">
        <Select
          options={categoryOptions}
          value={categoryOptions.find(
            (option) => option.value === selectedCategory
          )}
          onChange={(selected) => handleSelectChange("category", selected)}
          styles={customStyles}
          placeholder="Select Category"
          menuPortalTarget={document.body}
          isClearable
        />
      </div>
      <div className="w-full">
        <Select
          options={itemNameOptions}
          value={itemNameOptions.find(
            (option) => option.value === selectedItemName
          )}
          onChange={(selected) => handleSelectChange("itemName", selected)}
          styles={customStyles}
          placeholder="Select Item Name"
          menuPortalTarget={document.body}
          isClearable
        />
      </div>
    </>
  );
};

export default FilterDropdowns;
